import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

interface FakeFileShape {
  isFakeFile?: boolean;
  size?: number;
  name?: string;
  [key: string]: unknown;
}

export const FILE_DETAILS_FORM_VALIDATION_SCHEMA = yupResolver(
  yup.object({
    fileName: yup
      .object()
      .nullable()
      .required('Please select an option from the list or use your own one'),
    file: yup
      .mixed()
      .required()
      .test('required', 'The file is required', (value: unknown) => {
        const candidate = value as FakeFileShape | File | null | undefined;
        const isFile =
          candidate instanceof File ||
          !!(candidate as FakeFileShape | null)?.isFakeFile;

        return isFile;
      })
      .test('size', 'The file must be less than 50 MB', (value: unknown) => {
        const candidate = value as FakeFileShape | File | null | undefined;

        return !!candidate && (candidate as FakeFileShape).size !== undefined
          ? ((candidate as FakeFileShape).size ?? 0) < 52428800
          : false;
      })
      .test(
        'name',
        'The file must be either pdf, pptx, xlsx or docx',
        (value: unknown) => {
          const candidate = value as FakeFileShape | File | null | undefined;
          const formatsRegexp = /(\.pdf|\.pptx|\.docx|\.xlsx)$/i;

          return (
            !!candidate &&
            !!formatsRegexp.exec((candidate as FakeFileShape).name ?? '')
          );
        }
      ),
  })
);

export const FILES_STATUSES = {
  ACTIVE: 'ACTIVE',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
} as const;

export type FilesStatus = (typeof FILES_STATUSES)[keyof typeof FILES_STATUSES];

interface AlertConfig {
  heading: string;
  variant: 'success' | 'warning' | 'error' | 'info';
}

export const ALERTS: Record<string, AlertConfig> = {
  SUCCESS: { heading: 'File was succesfully uploaded', variant: 'success' },
  ACTIVE: { heading: 'File was succesfully activated', variant: 'success' },
  UPDATED: { heading: 'File was succesfully updated', variant: 'success' },
  HIDDEN: { heading: 'File was hidden', variant: 'warning' },
  ARCHIVED: { heading: 'File was archived', variant: 'error' },
};
